// extracted by mini-css-extract-plugin
export default {"navigation":"XqDJfzn7","firstItem":"Lc9RmiGU","thumb":"aFOBDQxt"};